import { AddCircle } from "@mui/icons-material";
import { Autocomplete, Popover, TextField } from "@mui/material";
import image from "assets/img/default/pie.png";
import CustomImage from "components/CustomImage";
import CustomText from "components/typography/CustomText";
import { getPies } from "models/piesModel";
import React, { useEffect } from "react";

export default function FlavourItem({ pieIndex = 0, pie = {}, onChange }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pies, setPies] = React.useState([]);

  const handleChangePie = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (newValue) => {
    onChange(newValue, pieIndex);
    setAnchorEl(null);
  };

  useEffect(() => {
    getPies({
      onFinish: (res = []) => {
        setPies(res ?? []);
      },
    });
    //eslint-disable-next-line
  }, []);

  return (
    <div className="relative h-full">
      {!pie ? (
        <div className="relative w-full h-full rounded shadow-logo">
          <div
            className="relative h-44 w-full flex flex-col flex-stretch justify-center items-center cursor-pointer"
            onClick={handleChangePie}
          >
            <AddCircle />
            <CustomText className="pt-3" variant="body2" bold={600}>
              Add a Flavour
            </CustomText>
          </div>
        </div>
      ) : (
        <div className="relative w-full h-full rounded shadow-logo">
          <div className="relative h-44 w-full flex flex-col flex-stretch">
            <div
              className={`w-32 h-full mx-auto relative rounded overflow-hidden cursor-pointer transition-all duration-300`}
            >
              <CustomImage
                className="w-full object-contain overflow-hidden -mt-5"
                src={pie?.image ?? image}
                ait={pie?.name ?? ""}
                title={pie?.name ?? ""}
              />
            </div>
            <div className="rounded">
              <CustomText align="center" variant="h5" color="secondary">
                {pie?.name ?? ""}
              </CustomText>
            </div>
            <div
              className="pb-4 rounded overflow-hidden cursor-pointer"
              onClick={handleChangePie}
            >
              <CustomText
                variant="body2"
                bold={600}
                align="center"
                color="primary"
              >
                Change
              </CustomText>
            </div>
          </div>
        </div>
      )}
      <Popover
        sx={{ boxShadow: "none" }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Autocomplete
          size="small"
          className="w-60"
          disableClearable
          sx={{ background: "#fff" }}
          options={pies}
          getOptionLabel={(option) => option.name ?? ""}
          value={pie ?? {}}
          onChange={(event, newValue) => handleChange(newValue)}
          renderInput={(params) => <TextField {...params} />}
        />
      </Popover>
    </div>
  );
}
